// extracted by mini-css-extract-plugin
export default {"actionButtons":"saveSakDialog_actionButtons__JckRY"};